import React, { useState, useCallback, useEffect, useMemo, useRef } from "react";
import getIcon from "../../utils/Icon";
import diamond from '../../assets/card/diamond.png';
import share from '../../assets/card/share.png';
import cryptoandcrystal from '../../assets/card/crypto-and-crystal.png';
import CoinBadge from "../coin_badge/CoinBadge";
import EditPencilIcon from '../icons/EditPencilIcon';
import ExpandIcon from '../icons/ExpandIcon';
import ParticipantsIcon from '../icons/ParticipantsIcon';
import CupIcon from '../icons/CupIcon';
import tokenApi from "../../api/tokenApi";
import reportWebVitals from "../../reportWebVitals";
import CrystalsApi from "../../api/CrystalsApi";
import paymentApi from "../../api/paymentApi";
import PromosApi from "../../api/PromosApi";
import blockchainApi from "../../api/blockchainApi";
import feeApi from "../../api/feeApi";
import { useDispatch } from "react-redux";
import { setSelectedPromo, setEditMode } from "../../store/slices/selectedPromoSlice";
import { setPage } from "../../store/slices/pageSlice";
import { setPaymentType } from "../../store/slices/paymentSlice";
import { clearPromoFormFields } from "../../utils/promoFormDraft";
import CrystalsIconBadge from '../../assets/card/CrystalsOnly.svg';
import CryptoIconBadge from '../../assets/card/CryptoOnly.svg';
import CrystalsCryptoIconBadge from '../../assets/card/CryptoandCrystals.svg';
import CrystalsIcon from '../../assets/icon/bottomBar/Crystals.png';
import CCIcon from '../../assets/icon/bottomBar/cc.png';
import CryptoIcon from '../../assets/icon/bottomBar/crypto.png';
import { Modal } from '../Modal/Modal';
import left_back from '../../assets/icon/left_back.png';
export default function PromoCard({ promo, onClick, isMyPromo = false, onStartSuccess, isBonusOffer = false, onBonusClick }) {
    const dispatch = useDispatch();
    console.log(promo);

    const [showTooltip, setShowTooltip] = useState(false);
    const [token, setToken] = useState('');
    const [status, setStatus] = useState('Deposit');
    const [crystal, setCrystal] = useState({});
    const [buttonColor, setButtonColor] = useState('#207FE0');
    const [isPaid, setIsPaid] = useState(null);
    const [paymentLoading, setPaymentLoading] = useState(false);
    // null = не загружено / не blockchain promo, объект = on-chain данные
    const [onChainInfo, setOnChainInfo] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);
    const [copied, setCopied] = useState(false);
    const [bonusFee, setBonusFee] = useState(null); // fee для бонусной карточки
    const [displayFee, setDisplayFee] = useState(null); // реальный cost на карточке
    
    // Определяем тип промо и соответствующий текст/иконку
    const promoTypeInfo = useMemo(() => {
        const promoType = promo?.promoType || 'crystalsAndCrypto';
        
        switch (promoType) {
            case 'onlyCrystals':
                return {
                    text: 'Crystals',
                    icon: CrystalsIconBadge
                };
            case 'cryptoOnly':
                return {
                    text: 'Crypto',
                    icon: CryptoIconBadge
                };
            case 'crystalsAndCrypto':
            default:
                return {
                    text: 'Crystals and Crypto',
                    icon: CrystalsCryptoIconBadge
                };
        }
    }, [promo?.promoType]);

    const totalCrystalBudget = useMemo(() => {
        const positions = promo?.category?.positions || [];
        return positions.reduce((sum, p) => {
            const budget = Number(p?.budget);
            if (!Number.isNaN(budget) && budget > 0) {
                return sum + budget;
            }
            const winners = Number(p?.winners) || 0;
            const drop = Number(p?.dropPerWinner) || 0;
            return sum + (winners * drop);
        }, 0);
    }, [promo?.category?.positions]);

    // промоутер (первый из массива)
    const promoter = promo?.promoters?.[0];
    const fullName = promoter?.name || "";

    // короткое имя с обрезкой до 5 символов
    const shortName = fullName.length > 18 ? fullName.slice(0, 18) + '...' : fullName;

    // процент призовых мест относительно макс. участников
    const maxParticipants = promo?.maxParticipantsCount ? promo?.maxParticipantsCount : promo?.participantsCount
    const prizePlaces = promo?.prizePlacesCount ?? 0;
    const percent = maxParticipants > 0
        ? Math.round((prizePlaces / maxParticipants) * 100)
        : 0;
    const percentText = `${percent}%`;

    const getToken = async () => {
        try {
            const response = await tokenApi.lookupToken(promo?.tokenType, 't');
            setToken(response.logoPath);
            console.log('lookupToken response:', response);
        } catch (err) {
            console.error('lookupToken error:', err);
        }
    };

    const getCrystal = async () => {
        // Для типа "cryptoOnly" кристаллов нет
        if (promo?.promoType === 'cryptoOnly') {
            setCrystal([]);
            return;
        }
        
        try {
            const result = await CrystalsApi.getGemsByPositions([promo?.category?.positions?.length]);
            console.log('getCrystal result:', result);
            setCrystal(result);
        } catch (err) {
            console.error('cant find gem : ', err);
        }
    };


    useEffect(() => {
        getToken();
        getCrystal();
    }, [promo?.promoType, promo?.category?.positions?.length]);

    // Загрузка fee для бонусной карточки (предложение или созданное промо)
    const isBonusPromo = promo?.isBonusPromo === true;

    const normalizeFeeAmount = (fee) => {
        if (fee == null) return null;
        if (typeof fee === 'number') return fee;
        const n = Number(fee?.amount ?? fee?.fee ?? fee);
        return Number.isFinite(n) ? n : null;
    };

    useEffect(() => {
        if (!isBonusOffer && !isBonusPromo) return;
        const participants = promo?.participantsCount || promo?.maxParticipantsCount || promo?._bonusPosition?.maxParticipants || 50;
        feeApi.calculateGemFeePreview(participants)
            .then((fee) => {
                setBonusFee(fee);
            })
            .catch((err) => {
                console.error('[PromoCard] calculateGemFeePreview error:', err);
                setBonusFee(null);
            });
    }, [isBonusOffer, isBonusPromo, promo?.participantsCount, promo?.maxParticipantsCount, promo?._bonusPosition?.maxParticipants]);

    // Реальный cost для обычных промо (вместо хардкода $87.84)
    useEffect(() => {
        if (isBonusOffer || isBonusPromo) {
            setDisplayFee(null);
            return;
        }
        if (!promo?.id) {
            setDisplayFee(null);
            return;
        }

        const participants = promo?.participantsCount || promo?.maxParticipantsCount || 0;
        if (!participants) {
            setDisplayFee(null);
            return;
        }

        let cancelled = false;
        const isGem = promo?.promoType === 'onlyCrystals';
        const request = isGem
            ? feeApi.calculateFeeGem(promo.id, participants)
            : feeApi.calculateFee(promo.id, participants);

        request
            .then((fee) => {
                if (cancelled) return;
                setDisplayFee(normalizeFeeAmount(fee));
            })
            .catch((err) => {
                if (cancelled) return;
                console.error('[PromoCard] calculateFee error:', err);
                setDisplayFee(null);
            });

        return () => { cancelled = true; };
    }, [
        isBonusOffer,
        isBonusPromo,
        promo?.id,
        promo?.promoType,
        promo?.participantsCount,
        promo?.maxParticipantsCount,
    ]);

    // Подгружаем on-chain статус — источник истины для blockchain-промо
    useEffect(() => {
        if (!isMyPromo || !promo?.id) return;
        if (promo?.status === 'ACTIVE' || promo?.status === 'COMPLETED' || promo?.status === 'MANUALLY_COMPLETED') return;
        blockchainApi.getPromoBlockchainInfo(promo.id)
            .then(res => {
                const info = res?.data || res;
                // Blockchain-промо распознаём по ЛЮБОМУ on-chain следу, не только по
                // chainId: форма иногда не проставляет его при создании, а депозит/фи
                // при этом реально проходят — без этого карточка падала в legacy
                // checkPayment и вечно показывала Deposit при funded-промо.
                const isOnChain = info?.chainId || info?.depositTxHash || info?.feeTxHash || info?.blockchainStatus;
                if (isOnChain) setOnChainInfo(info);
                else setOnChainInfo(null);
            })
            .catch(() => setOnChainInfo(null));
    }, [isMyPromo, promo?.id, promo?.status]);

    useEffect(() => {
        const pid = promo?.id != null ? Number(promo.id) : NaN;
        if (!isMyPromo || !promo?.id || isNaN(pid)) {
            setIsPaid(null);
            setPaymentLoading(false);
            if (promo?.id !== 'test-completed-001') {
                console.log('[PromoCard] skip checkPayment: isMyPromo=', isMyPromo, 'promoId=', promo?.id, 'pid=', pid);
            }
            return;
        }
        let cancelled = false;
        setPaymentLoading(true);
        console.log('[PromoCard] calling checkPayment for promoId=', pid);

        async function run() {
            try {
                const res = await paymentApi.checkPayment(pid);
                if (cancelled) return;
                console.log('[PromoCard] checkPayment response: paid=', res?.paid, 'fee=', res?.fee, '| full:', res);
                setIsPaid(!!res?.paid);
            } catch (err) {
                if (cancelled) return;
                setIsPaid(false);
                console.error('[PromoCard] checkPayment failed:', err?.response?.data ?? err?.message ?? err);
            } finally {
                if (!cancelled) setPaymentLoading(false);
            }
        }
        run();
        return () => { cancelled = true; };
    }, [isMyPromo, promo?.id]);

    useEffect(() => {
        // Для завершённых промо — специальный статус
        if (promo?.status === 'COMPLETED' || promo?.status === 'MANUALLY_COMPLETED') {
            setStatus('Completed');
            setButtonColor('#6B7280'); // серый
            return;
        }
        
        if (isMyPromo) {
            if (promo?.status === 'ACTIVE') {
                setStatus('live');
                return;
            }
            // Blockchain-промо: Start ТОЛЬКО когда и deposit, и fee оплачены on-chain
            if (onChainInfo) {
                const fullyFunded =
                    onChainInfo.blockchainStatus === 'funded' ||
                    (onChainInfo.depositTxHash && onChainInfo.feeTxHash);
                if (fullyFunded) {
                    setStatus('Start');
                    setButtonColor('#FFC813');
                } else {
                    setStatus('Deposit');
                    setButtonColor('#207FE0');
                }
                return;
            }
            // Legacy не-blockchain промо: используем checkPayment
            if (paymentLoading || isPaid === null) {
                setStatus('Deposit');
                setButtonColor('#207FE0');
                return;
            }
            if (!isPaid) {
                setStatus('Deposit');
                setButtonColor('#207FE0');
                return;
            }
            setStatus('Start');
            setButtonColor('#FFC813');
            return;
        }
        switch (promo?.status) {
            case 'PENDING':
                setStatus('Deposit');
                setButtonColor('#207FE0');
                break;
            case 'ACTIVE':
                setStatus('live');
                break;
            default:
                setStatus('Deposit');
                setButtonColor('#207FE0');
                break;
        }
    }, [isMyPromo, promo?.status, isPaid, paymentLoading, onChainInfo]);

    // показать тултип
    const handlePressStart = useCallback((e) => {
        e.stopPropagation();
        setShowTooltip(true);
    }, []);

    // скрыть тултип
    const handlePressEnd = useCallback((e) => {
        e.stopPropagation();
        setShowTooltip(false);
    }, []);

    // обработчик клика на карточку
    // Переход на страницу промо: завершённые и свои live — на статистику,
    // остальные — на страницу с задачами.
    const openPromoPage = useCallback((e) => {
        e.stopPropagation();

        // Бонусное предложение — переход на создание промо
        if (isBonusOffer) {
            if (onBonusClick) {
                onBonusClick(promo);
            } else {
                // По умолчанию — переход на форму создания кристального промо
                dispatch(setPage({ id: 1, name: 'PromoFormCrystals' }));
            }
            return;
        }
        
        if (promo) {
            console.log('🟢 PromoCard: Клик на карточку, промо:', promo);
            console.log('🟢 PromoCard: Устанавливаем selectedPromo в Redux');
            dispatch(setSelectedPromo(promo));
            
            // Проверяем статус промо
            const isCompleted = promo?.status === 'COMPLETED' || promo?.status === 'MANUALLY_COMPLETED';
            const isActive = promo?.status === 'ACTIVE';
            
            if (isCompleted) {
                // Завершённое промо — всегда CompletedPromoLayout
                console.log('🟢 PromoCard: Промо завершено, переходим на страницу CompletedPromo (id: 8)');
                dispatch(setPage({ id: 8, name: 'CompletedPromo' }));
            } else if (isActive && isMyPromo) {
                // Активное промо, МЫ владелец — показываем CompletedPromoLayout (live-статистика)
                console.log('🟢 PromoCard: Своё активное промо, переходим на CompletedPromo (id: 8)');
                dispatch(setPage({ id: 8, name: 'CompletedPromo' }));
            } else {
                // Активное чужое промо (подписан) или PENDING — страница с задачами
                console.log('🟢 PromoCard: Чужое/pending промо, переходим на PromoDetails (id: 5) с задачами');
                dispatch(setPage({ id: 5, name: 'PromoDetails' }));
            }
            
            if (onClick) {
                onClick(promo);
            }
        } else {
            console.warn('⚠️ PromoCard: promo отсутствует при клике');
        }
    }, [promo, dispatch, onClick, isBonusOffer, onBonusClick, isMyPromo]);

    const handleDepositClick = useCallback((e) => {
        e.stopPropagation();
        if (promo) {
            dispatch(setSelectedPromo(promo));
            dispatch(setPaymentType('deposit'));
            dispatch(setPage({ id: 7, name: 'Payment' }));
        }
    }, [promo, dispatch]);

    const handleStartClick = useCallback((e) => {
        e.stopPropagation();
        if (!promo?.id || status !== 'Start') return;
        PromosApi.startPromo(promo.id)
            .then(() => {
                onStartSuccess?.();
            })
            .catch((err) => {
                console.error('[PromoCard] start promo failed:', err);
            });
    }, [promo?.id, status, onStartSuccess]);

    const handleShareClick = useCallback((e) => {
        e.stopPropagation();
        if (!isMyPromo) return;
        setCopied(false);
        setShowShareModal(true);
    }, [isMyPromo]);

    const handleCopyRefLink = useCallback(() => {
        const link = promo?.referralLink || '';
        if (!link) return;
        navigator.clipboard.writeText(link).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch(() => {});
    }, [promo?.referralLink]);

    const handleCloseShareModal = useCallback(() => {
        setShowShareModal(false);
        setCopied(false);
    }, []);

    const handleExploreClick = useCallback((e) => {
        e.stopPropagation();
        if (promo) {
            dispatch(setSelectedPromo(promo));
            dispatch(setPage({ id: 5, name: 'PromoDetails' }));
        }
    }, [promo, dispatch]);

    const [editLoading, setEditLoading] = useState(false);
    const editRequestIdRef = useRef(0);

    const openEditForm = useCallback((promoData) => {
        if (!promoData) return;

        // Сбрасываем черновик, чтобы не мелькали данные предыдущего промо
        clearPromoFormFields(dispatch);

        const mode = isPaid ? 'limited' : 'full';
        dispatch(setSelectedPromo(promoData));
        dispatch(setEditMode({ isEditMode: true, editMode: mode }));

        const promoType = promoData?.promoType || 'crystalsAndCrypto';
        switch (promoType) {
            case 'onlyCrystals':
                dispatch(setPage({ id: 1, name: 'PromoFormCrystals' }));
                break;
            case 'cryptoOnly':
                dispatch(setPage({ id: 3, name: 'PromoFormOnlyCrypto' }));
                break;
            case 'crystalsAndCrypto':
            default:
                dispatch(setPage({ id: 2, name: 'PromoFormCryptoAndCrystals' }));
                break;
        }
    }, [dispatch, isPaid]);

    const handleEditClick = useCallback(async (e) => {
        e.stopPropagation();
        if (!promo?.id || editLoading) return;

        const requestId = ++editRequestIdRef.current;
        setEditLoading(true);

        try {
            // Ждём свежие данные — иначе при быстром клике форма может открыться пустой
            const freshPromo = await PromosApi.getById(promo.id);
            if (requestId !== editRequestIdRef.current) return;
            openEditForm(freshPromo || promo);
        } catch (err) {
            console.error('[Edit] Failed to fetch promo before open:', err);
            if (requestId !== editRequestIdRef.current) return;
            // Не открываем форму без данных — пользователь может попробовать снова
        } finally {
            if (requestId === editRequestIdRef.current) {
                setEditLoading(false);
            }
        }
    }, [promo, editLoading, openEditForm]);

    console.log(crystal)
    const isLive = status === 'live';
    const isCompleted = status === 'Completed';
    const isLiveMyPromo = isLive && isMyPromo;
    const isCompletedMyPromo = isCompleted && isMyPromo;
    const isStartReady = status === 'Start';

    // Градиентная рамка для бонусных промо
    const hasBonusBorder = !isBonusOffer && isBonusPromo;
    
    const cardContent = (
        <div 
            className={`relative flex flex-col flex-1 min-w-0  rounded-[8px] bg-[#252323] ${isStartReady && !hasBonusBorder ? 'border-2 border-[#FFC813]' : ' '} ${promo ? 'cursor-pointer' : ''}`}
            // onClick={openPromoPage}
        >
            {/* Бейдж «1st Time Free» — прикреплён к верхнему левому углу (для предложения) */}
            {isBonusOffer && (
                <div 
                    className="absolute top-0 left-0 h-[30px] px-3 flex items-center gap-2 text-white whitespace-nowrap z-10"
                    style={{
                        background: 'linear-gradient(90deg, #DC1FFF 0%, #3A88F7 100%)',
                        borderRadius: '8px 0px 10px 0px',
                    }}
                >
                    <span style={{ fontFamily: 'Anton, sans-serif', fontSize: '11px' }}>
                        1st Time Free
                    </span>
                    {bonusFee != null && (
                        <span className="text-white/70 line-through text-[10px]" style={{ fontFamily: 'Lato, sans-serif' }}>
                            ${Number(bonusFee).toFixed(2)}
                        </span>
                    )}
                </div>
            )}

            {/* Бейдж «1st Time Free» — для созданных бонусных промо */}
            {!isBonusOffer && isBonusPromo && (
                <div 
                    className="absolute top-0 left-0 h-[30px] px-3 flex items-center gap-2 text-white whitespace-nowrap z-10"
                    style={{
                        background: 'linear-gradient(90deg, #DC1FFF 0%, #3A88F7 100%)',
                        borderRadius: '8px 0px 10px 0px',
                    }}
                >
                    <span style={{ fontFamily: 'Anton, sans-serif', fontSize: '11px' }}>
                        1st Time Free
                    </span>
                    {bonusFee != null && (
                        <span className="text-white/70 line-through text-[10px]" style={{ fontFamily: 'Lato, sans-serif' }}>
                            ${Number(bonusFee).toFixed(2)}
                        </span>
                    )}
                </div>
            )}

            <div className={'p-[12px]  '}>
                <div className={'w-full h-[24px] flex flex-row justify-between '}>

                        {status === 'live' ? (
                            <div className={'bg-[#2FD159] w-[48px] rounded-[40px] h-[26px] whitespace-nowrap text-[#000000] text-[13px] font-medium flex flex-row items-center justify-center'}>
                                Live
                            </div>
                        ) : isCompleted ? (
                            <div className={'bg-[#6B7280] w-[70px] rounded-[40px] h-[26px] whitespace-nowrap text-white text-[13px] font-medium flex flex-row items-center justify-center'}>
                                Finished
                            </div>
                        ) : isBonusOffer || isBonusPromo ? (
                            /* Пустое место под бейджем FREE */
                            <div className="w-[70px]" />
                        ) : (
                            <div className={'w-[64px] h-[26px] flex flex-row items-center justify-center rounded-[40px] bg-[#D3D3D3] font-roboto text-black text-[12px] font-medium'}>
                                {displayFee != null ? `$${Number(displayFee).toFixed(2)}` : '...'}
                            </div>
                        )}

                    <div
                        className={' gap-1 flex flex-row items-center justify-center whitespace-nowrap rounded-[40px] border border-white'}>
                        <img  height={14} src={promoTypeInfo.icon} alt={promoTypeInfo.text} className="object-contain" />
                        {/* <span>{promoTypeInfo.text}</span> */}
                    </div>

                    <div className={'w-[81px]   h-[24px] '}>
                            {/* Для onlyCrystals показываем бюджет кристаллов (сумма budget) */}
                            {promo?.promoType === 'onlyCrystals' && crystal[0]?.frontImage ? (
                                <CoinBadge 
                                    iconHeight={18} 
                                    iconWidth={18} 
                                    count={totalCrystalBudget} 
                                    token={`https://api.duotetra.quest/uploads/gems/${crystal[0]?.frontImage}`}
                                />
                            ) : (
                                <CoinBadge 
                                    iconHeight={18} 
                                    iconWidth={18} 
                                    count={promo?.currentAmount || promo?.totalAmount} 
                                    token={'https://api.duotetra.quest/'+token}
                                />
                            )}
                    </div>

                </div>

                <div className={'w-full flex flex-row justify-between h-[30px] mt-[14px]'}>
                    <div className={' pt-[6px] flex flex-row items-center'}>
                        {/* onlyCrystals / C&C — кристалл; cryptoOnly — бейдж с числом категорий */}
                        {promo?.promoType === 'cryptoOnly' ? (
                            <div
                                className="w-[24px] h-[24px] rounded-full border-2 flex items-center justify-center flex-shrink-0 bg-black"
                                style={{ borderColor: '#BC3EA4' }}
                            >
                                <span
                                    className="text-[11px] font-semibold leading-none"
                                    style={{ color: '#BC3EA4' }}
                                >
                                    {promo?.category?.positions?.length || 0}
                                </span>
                            </div>
                        ) : crystal[0]?.frontImage ? (
                            <img
                                width={24}
                                height={24}
                                src={'https://api.duotetra.quest/uploads/gems/'+crystal[0]?.frontImage}
                                alt="crystal"
                            />
                        ) : null}
                        <img
                            src={`https://api.duotetra.quest${promoter?.logo || ''}`}
                            className={`w-[24px] h-[24px] flex-shrink-0 rounded-full border border-white/10 ${
                                (promo?.promoType === 'cryptoOnly' || crystal[0]?.frontImage) ? 'ml-[8px]' : ''
                            }`}
                            alt=""
                        />

                        {/* Область с именем + тултип */}
                        <div
                            className={
                                'relative w-[130px] h-[20px] whitespace-nowrap text-[13px] ml-[5px] flex items-center justify-start select-none'
                            }
                            onMouseDown={handlePressStart}
                            onMouseUp={handlePressEnd}
                            onMouseLeave={handlePressEnd}
                            onTouchStart={handlePressStart}
                            onTouchEnd={handlePressEnd}
                        >
                            <span className="pointer-events-none">
                                {shortName}
                            </span>

                            {showTooltip && fullName && (
                                <div
                                    className={
                                        'absolute left-1/2 translate-x-[-50%] top-[100%] mt-[4px] ' +
                                        'px-[6px] py-[4px] rounded-[4px] ' +
                                        'bg-black text-white text-[10px] leading-[10px] ' +
                                        'whitespace-nowrap z-50 shadow-[0_2px_4px_rgba(0,0,0,0.6)]'
                                    }
                                >
                                    {fullName}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={' h-full  flex flex-row items-center gap-[8px]'}>
                        <div className={'flex w-[59px] xs:w-[49px] ml-1 flex-row h-[30px] items-center gap-[4px]'}>
                            <div className={'w-full h-full flex items-center justify-end translate-y-2.5'}>
                                <span className={'font-roboto text-[11px] text-[#959595]'}>
                                    &nbsp;
                                </span>
                                <span className={'text-[12px] font-roboto text-[#CFCFCF]'}>
                                    {promo?.maxParticipantsCount || promo?.participantsCount}
                                </span>
                            </div>
                            <div className="translate-y-2.5">
                                <ParticipantsIcon width={30} height={30} fill="#CFCFCF" className="scale-x-[-1]" />
                            </div>
                            
                        </div>

                        <div className={'flex w-[59px] xs:w-[49px] ml-1 flex-row h-[30px] items-end gap-[4px]'}>
                            <div className={'w-full h-full flex flex-col items-end'}>
                                {/* ЗДЕСЬ МЕНЯЕМ ТОЛЬКО ТЕКСТ. ВЁРСТКА И КЛАССЫ ТЕ ЖЕ */}
                                <span className={'font-roboto text-[11px] text-[#959595]'}>
                                    {percentText}
                                </span>
                                <span className={'text-[12px] font-roboto text-[#CFCFCF]'}>
                                    {promo?.prizePlacesCount}
                                </span>
                            </div>
                            <CupIcon width={18} height={18} />
                        </div>

                        {/* <div className={'w-[81px]   h-[24px] '}> */}
                            {/* Для onlyCrystals показываем бюджет кристаллов (сумма budget) */}
                            {/* {promo?.promoType === 'onlyCrystals' && crystal[0]?.frontImage ? (
                                <CoinBadge 
                                    iconHeight={18} 
                                    iconWidth={18} 
                                    count={totalCrystalBudget} 
                                    token={`https://api.duotetra.quest/uploads/gems/${crystal[0]?.frontImage}`}
                                />
                            ) : (
                                <CoinBadge 
                                    iconHeight={18} 
                                    iconWidth={18} 
                                    count={promo?.currentAmount || promo?.totalAmount} 
                                    token={'https://api.duotetra.quest/'+token}
                                />
                            )}
                        </div> */}
                    </div>

                </div>
            </div>

            {/* Для бонусной карточки — кнопка Create */}
            {isBonusOffer && (
                <>
                    <div className={'w-full border-t border-[#353232]'}/>
                    <div className="w-full p-[12px] flex flex-row items-center justify-end">
                        <div
                            className="w-[125px] h-[32px] rounded-[5px] flex items-center justify-center cursor-pointer border-2"
                            style={{
                                backgroundColor: '#207FE0',
                                borderColor: '#207FE0',
                            }}
                        >
                            <span className="text-[16px] font-medium text-white">Create</span>
                        </div>
                    </div>
                </>
            )}

            {/* Обычная нижняя панель для не-бонусных карточек */}
            {/* Не показываем для чужих COMPLETED промо */}
            {!isBonusOffer && (!isLive || isLiveMyPromo) && !(!isMyPromo && isCompleted) && <div className={'w-full border-t border-[#353232]'}/>}

            {!isBonusOffer && (!isLive || isLiveMyPromo) && !(!isMyPromo && isCompleted) && (
            <div className={`w-full p-[12px] gap-2 flex flex-row items-center ${(isLiveMyPromo || isCompletedMyPromo) ? 'justify-start' : 'justify-between'}`}>

                <div className={'flex flex-row items-center gap-[10px]'} data-no-click>
                    {/* Edit — только для PENDING, не для LIVE и не для COMPLETED */}
                    {isMyPromo && !isLive && !isCompleted && (
                    <div
                        className={`w-[32px] h-[32px] bg-[#121212] flex-shrink-0 flex flex-row items-center justify-center border border-white/20 rounded-[8px] ${editLoading ? 'opacity-50 pointer-events-none' : 'cursor-pointer hover:bg-white/5'}`}
                        onClick={handleEditClick}
                        aria-busy={editLoading}
                    >
                        <EditPencilIcon width={18} height={20} />
                        {/* <span className={'whitespace-nowrap text-[12px] font-medium '}>Edit</span> */}
                    </div>
                    )}
                    {/* Explore — для LIVE и COMPLETED */}
                    {isMyPromo && (isLive || isCompleted) && (
                    <div
                        className={'h-[32px] flex flex-row items-center px-[12px] gap-[6px] border border-white/20 rounded-[8px] cursor-pointer hover:bg-white/5'}
                        onClick={openPromoPage}
                    >
                        <img width={16} height={16} src={left_back} alt="explore"/>
                        <span className={'whitespace-nowrap text-[12px] font-medium'}>{isCompleted ? 'Results' : 'Explore'}</span>
                    </div>
                    )}
                </div>

                {/* Кнопка статуса — не для LIVE и не для COMPLETED */}
                {!isLive && !isCompleted && (
                    <div
                        className={
                            'w-full h-[32px] rounded-[5px] flex flex-row items-center justify-center cursor-pointer border-2'
                        }
                        style={{
                            backgroundColor: buttonColor,
                            borderColor: status === 'Start' ? '#FFC813' : buttonColor,
                        }}
                        onClick={
                            status === 'Deposit' ? handleDepositClick :
                            status === 'Start' ? handleStartClick :
                            (e) => e.stopPropagation()
                        }
                    >
                        <span className={`text-[16px] font-medium ${status === 'Start' ? 'text-black' : 'text-white'}`}>{status}</span>
                    </div>
                )}
                
                {/* Для COMPLETED показываем бейдж */}
                {isCompleted && (
                    <div
                        className="ml-auto w-[125px] h-[32px] rounded-[5px] flex flex-row items-center justify-center bg-[#374151] border-2 border-[#374151]"
                    >
                        <span className="text-[16px] font-medium text-white">Completed</span>
                    </div>
                )}

                {/* Share — только для своих промо в live: до старта ссылки ещё нет */}
                {isMyPromo && isLive && (
                    <div
                        className={'ml-auto w-[38px] h-[32px] flex-shrink-0 flex flex-col items-center justify-center border border-white/20 rounded-[8px] cursor-pointer hover:bg-white/5'}
                        onClick={handleShareClick}
                    >
                        <img width={16} height={16} src={share}/>
                    </div>
                )}

                {isMyPromo && (
                    <div 
                        className={'w-[32px] h-[32px] bg-[#121212] flex-shrink-0 flex flex-col items-center justify-center border border-white/20 rounded-[8px] cursor-pointer hover:bg-white/5'}
                        onClick={handleExploreClick}
                    >
                        <ExpandIcon width={19} height={19} />
                    </div>
                )}
            </div>
            )}
        </div>
    );

    // Оборачиваем в gradient border для бонусных промо
    const card = hasBonusBorder ? (
        <div 
            className="rounded-[10px] p-[2px] flex-1 min-w-0"
            style={{
                background: 'linear-gradient(90deg, #DC1FFF 0%, #3A88F7 100%)',
            }}
        >
            {cardContent}
        </div>
    ) : cardContent;

    return (
        <>
            {card}
            <Modal isOpen={showShareModal} onClose={handleCloseShareModal}>
            <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2">
                    <img src={share} alt="" className="w-5 h-5 opacity-80" />
                    <h3 className="text-base font-medium text-white">Реферальная ссылка</h3>
                </div>
                <div className="flex flex-row items-stretch rounded-lg border border-border_square bg-ipt overflow-hidden">
                    <input
                        type="text"
                        readOnly
                        value={promo?.referralLink || ''}
                        placeholder="Ссылка появится после старта промо"
                        className="flex-1 min-w-0 px-3 py-2.5 bg-transparent border-0 text-accent_text text-sm placeholder:text-accent/60 focus:outline-none focus:ring-0"
                    />
                    <button
                        type="button"
                        onClick={handleCopyRefLink}
                        disabled={!promo?.referralLink}
                        title={copied ? 'Скопировано' : 'Скопировать'}
                        className="flex-shrink-0 flex items-center justify-center w-11 py-2.5 pr-2.5 pl-2 border-l border-border_square text-accent_text hover:bg-white/5 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                    >
                        {copied ? (
                            <svg className="w-5 h-5 text-dep" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                        ) : (
                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                            </svg>
                        )}
                    </button>
                </div>
            </div>
        </Modal>
        </>
    );
}
